var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"createdButton",attrs:{"type":"primary"},on:{"click":function($event){return _vm.onCreated()}}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }